import { initInterceptor } from "../axios/interceptor";
import { setServerResponceLanguage } from "../axios/languages";
import { setLocalizations } from "../localization/localization";
export var appInitialization = function () {
    setLocalizations();
    initInterceptor();
    setServerResponceLanguage();
};
